import React from "react";
import { SvgIcon } from "@mui/material";
import styles from "../../icons/iconStyles";

const WarningIcon = ({ color }: any) => {
  return (
    <SvgIcon style={styles.icon}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.667969 14.3334H15.3346L8.0013 1.66675L0.667969 14.3334ZM8.66797 12.3334H7.33464V11.0001H8.66797V12.3334ZM8.66797 9.66675H7.33464V7.00008H8.66797V9.66675Z"
          fill={color || "#747881"}
        />
      </svg>
    </SvgIcon>
  );
};

export default WarningIcon;
